export default {
  'component.tagSelect.expand': 'Expand',
  'component.tagSelect.collapse': 'Collapse',
  'component.tagSelect.all': 'All',
  'component.themeToggle.switchToLight': 'Switch to light mode',
  'component.themeToggle.switchToDark': 'Switch to dark mode',
};
